/**
 * このシステムの公開URLを決める唯一の入口。
 *
 * 以前は `https://reservation-customer-booking.web.app` のような
 * Firebase の既定ドメインを、画面ごとに直接書いていた（5種類・42箇所）。
 * ドメインを変えるたびに書き漏らしが出て、
 * 「卓のQRだけ古いドメインを指したまま」のような食い違いが起きる。
 *
 * すべて easymenu-app.com に集約する。
 *   /                  … LP
 *   /staff-dashboard/  … 店舗ダッシュボード（オーナー・店長）
 *   /booking/          … お客様のQR注文・予約
 *   /admin/            … 運営の管理画面
 *   /public/{id}/      … QRの入口ページ（既存。印刷済みのQRが指しているので触らない）
 *
 * easymenu-translation.com は既存の飲食店が使っているので別物。ここには含めない。
 */

/** すべての公開URLの土台 */
export const SITE_ORIGIN = 'https://easymenu-app.com';

export const SITE_PATHS = {
  landing: '/',
  staffDashboard: '/staff-dashboard',
  booking: '/booking',
  admin: '/admin',
} as const;

const join = (path: string) => `${SITE_ORIGIN}${path}`;

/** LP */
export const landingUrl = () => join(SITE_PATHS.landing);

/** 店舗ダッシュボード */
export const staffDashboardUrl = (sub = '') =>
  join(`${SITE_PATHS.staffDashboard}${sub}`);

/** お客様のQR注文（卓ごと）。卓に貼るQRコードが指す先。 */
export const tableOrderUrl = (shopCode: string, tableId: string) =>
  join(`${SITE_PATHS.booking}/order/${shopCode}/${tableId}`);

/** お客様の店舗ページ（予約・メニュー） */
export const customerShopUrl = (shopCode: string) =>
  join(`${SITE_PATHS.booking}/${shopCode}`);

/** 運営の管理画面 */
export const adminUrl = (sub = '') => join(`${SITE_PATHS.admin}${sub}`);

/** LINE の webhook などに出すエンドポイント */
export const bookingOrigin = () => join(SITE_PATHS.booking);
